import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class EmbeddedIoTPlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: [], andTechs: false, techs: [], andSearch: false, search: ['Embedded', 'IoT'], };

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Embedded and IoT Development Capabilities</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>While I am not an electrical engineer, I have decades of electronics experience. My home office/dev lab is equipped with state-of-the-art DSO’s, Logic Analyzers in-circuit debuggers for various uControllers, etc., etc., etc., etc. I have executed embedded contracts in which I developed firmware for IoT connected devices as well as standalone devices. My work has included Raspberry Pi’s (all versions), Arduinos, Linux/Android SBC’s and custom devices based on x86, ARM and Microchip PIC microcontrollers. The application have included process and motion control, computer vision, vehicle tracking and sensor data telemetry over embedded wifi, embedded cellular and embedded mesh and LoRa networks.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <br/>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Embedded and IoT projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmbeddedIoTPlatform



// WEBPACK FOOTER //
// src/Platforms/EmbeddedIoTPlatform.js